<!-- MENU MOVIL PARA USUARIO NORMAL -->


<template>

  <div>
<OpenLinksTecDialog ref="componenteHijoOpenLinksTec"></OpenLinksTecDialog>

    

  <v-navigation-drawer
    v-model="drawer"
    app
    temporary
  >



    
    <v-flex xs12 class="pt-5 grey lighten-5 pb-2 text-center">
      <v-img
            :src="require('@/assets/img/use/logoteczoav1.png')"
            :lazy-src="require('@/assets/img/use/logoteczoav1.png')"
            width="10vh"
            class="mx-auto">
            <v-layout
                slot="placeholder"
                fill-height
                align-center
                justify-center
                ma-0
            >
                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
            </v-layout>
      </v-img>
          
    </v-flex>
   


        <v-list-item>
          <v-list-item-avatar>
            <v-img src="@/assets/img/team/avatar.png"></v-img>
          </v-list-item-avatar>
  
          <v-list-item-content>
            <v-list-item-title>Menu TecZoa</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
  
        <v-divider></v-divider>
  
         <v-list dense>

          <!-- HOME -->
          <v-list-item @click="irAHome">
            <v-list-item-icon>
              <v-icon>mdi-home</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>HOME</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
  
          <v-list-item
            v-for="(link, i) in linksStore"
            :key="i"
            :to="link.to"
          >
            <v-list-item-icon>
              <v-icon  @click="onClick($event, link)">{{ link.icon }}</v-icon>
            </v-list-item-icon>
  
            <v-list-item-content>
              <v-list-item-title >{{ link.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>


        </v-list>

        <v-divider class="my-2"></v-divider>

        <!-- ITEM: CARRITO -->
        <v-list-item
          @click="irAlCarrito"
          style="background: #fff3e0; border-radius: 8px; margin: 0 8px;"
          class="mb-1"
        >
          <v-list-item-icon>
            <v-badge :content="badgeCarrito" :value="cantidadCarrito > 0" color="red" overlap>
              <v-icon color="orange darken-2">mdi-cart</v-icon>
            </v-badge>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold" style="color: #e65100;">
              CARRITO
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-icon color="orange darken-2">mdi-open-in-new</v-icon>
          </v-list-item-action>
        </v-list-item>
        <!-- FIN CARRITO -->

        <!-- ITEM DESTACADO: LINKS TEC -->
        <v-list-item
          @click="openLinksTec()"
          style="background: #e3f2fd; border-radius: 8px; margin: 0 8px;"
        >
          <v-list-item-icon>
            <v-icon color="#1a73e8">mdi-link-plus</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold" style="color: #1a73e8;">
              LINKS TEC
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-icon color="#1a73e8">mdi-open-in-new</v-icon>
          </v-list-item-action>
        </v-list-item>
        <!-- FIN LINKS TEC -->

        </v-list>
  </v-navigation-drawer>

    </div>
</template>

<script>
import ChapterDetails from '@/assets/data/chapterDetails.json'


import OpenLinksTecDialog from "@/components/tienda/menu/OpenLinksTecDialog.vue"
  // Utilities
  import {
    mapGetters,
    mapMutations
  } from 'vuex'
  export default {
    name: 'MenuMovilStore',
    data() {
      return {
        ChapterDetails:ChapterDetails
      }
    },
    components:{
          OpenLinksTecDialog,

    },
    computed: {
      ...mapGetters(['linksStore']),
      cantidadCarrito() {
        return this.$store.getters.cantidadCarrito;
      },
      badgeCarrito() {
        return this.cantidadCarrito > 99 ? '99+' : String(this.cantidadCarrito);
      },
      drawer: {
        get () {
          return this.$store.state.drawer
        },
        set (val) {
          this.setDrawer(val)
        }
      }
    },
    methods: {

irAlCarrito() {
      this.$router.push('/store-carrito');
    },

    irAHome() {
      this.setDrawer(false);
      if (this.$route.path !== '/store/all') {
        this.$router.push('/store/all');
      }
    },

openLinksTec()
      {

         this.$refs.componenteHijoOpenLinksTec.openDialog();

      },


      ...mapMutations(['setDrawer']),
      onClick (e, item) {
        e.stopPropagation()
        if (item.to === '/') {
          this.$vuetify.goTo(0)
          this.setDrawer(false)
          return
        }
        if (item.to || !item.href) return
        this.$vuetify.goTo(item.href)
        this.setDrawer(false)
      }
    },
  perfilEdit(){

    var identificador = localStorage.getItem('identificador');


if (identificador) {
      // Navegar a la ruta con el identificador como parámetro
      this.$router.push(`/perfil/${identificador}/add/`);
    } else {
      console.error('No se encontró ningún identificador en el Local Storage.');
    }

  }
  }
</script>


